import { HttpQuery } from "@/interfaces/httpQuery";
import { Location } from "@/interfaces/location";
import { EventBus, policyList, store } from "@/internal";
import { API_URIS } from "@/utils/constants";
import { ActionSubheader, TableAction } from "helix-vue-components";
import Http2Service from "./http2.service";

export class LocationService extends Http2Service {
  constructor() {
    super();
  }

  /**
   * Retrieves the list of locations.
   * @param query?: HttpQuery
   * @returns Promise<Location[]>
   */
  public async getLocations(query?: HttpQuery): Promise<Location[]> {
    const response = await this.get(API_URIS.LOCATION, query);
    return response.data.data;
  }

  public getGeneralActions(): ActionSubheader[] {
    return [
      {
        icon: "fal fa-plus",
        class: "buttonClass_5",

        id: "btn_create_locat",
        componentName: "TableButtonComponent",
        disabled: () => {
          const availability =
            store.getters["AccountManagementModule/availability"];
          return !!availability && !availability.locations.available;
        },
        visibleCondition: () => {
          const display = store.getters["authModule/hasPermission"](
            policyList.createLocations
          );
          return display;
        },
        tooltip: {
          text: "location_message",
          displayCondition: () => {
            const availability =
              store.getters["AccountManagementModule/availability"];
            return !!availability && !availability.locations.available;
          }
        },
        action: (...arg: any[]) => {
          EventBus.$emit("route", {
            name: "add-location"
          });
        }
      }
    ];
  }

  public getRowActions(viewFlag: boolean, modifyFlag: boolean): TableAction[] {
    return [
      {
        icon: modifyFlag ? "fal fa-pen" : "fal fa-eye",
        class: "table__actions",
        id: "btn_edit_locat",
        visibleCondition: () => {
          return viewFlag;
        },
        action: (...arg: any[]) => {
          EventBus.$emit("route", {
            name: modifyFlag ? "edit-location" : "view-location",
            params: {
              id: arg[0].id,
              currentModel: arg[0]
            }
          });
        }
      }
    ];
  }
}

export const LOCATION_SERVICE = new LocationService();
